<template>
  <div class="col-md-4 ml-auto mr-auto">
    <form @submit.prevent="login">
      <card class="card-login card-plain">

        <div slot="header">
          <div class="logo-container">
            <img :src="logoSrc" alt="">
          </div>
        </div>

        <div>
          <div class="text-center login-title">
            <h3>
              <router-link class="link footer-link" to="/register">
                {{ $t("Login.GAA.Name") }}
              </router-link>
            </h3>
          </div>
          <p style="color:#BA0000;" v-if="signinError"><strong>{{ $t("Login.GAA.Sign_In_Error") }}</strong></p>
          <p style="color:#BA0000;" v-show="signLockError">
            <strong>{{ $t("Login.GAA.Sign_Lock_Error") }}</strong>
          </p>
          <!-- <fg-input v-model="model.email"
                    v-validate="'required|email'"
                    name="username"
                    :error="getError('username')"
                    class="no-border form-control-lg"
                    placeholder="Email"
                    addon-left-icon="now-ui-icons ui-1_email-85">
          </fg-input>

          <fg-input v-model="model.password"
                    v-validate="'required|min:5'"
                    type="password"
                    name="password"
                    :error="getError('password')"
                    class="no-border form-control-lg"
                    placeholder="Password"
                    addon-left-icon="now-ui-icons ui-1_lock-circle-open">
          </fg-input> -->
          <p v-show="signLockError" class="nav-align-center" >
            <strong style="color:#BA0000;">請於{{ formattedTime }}後再試</strong>
          </p>
        </div>

        <div slot="footer">
          <div class="d-block text-center mb-2">{{$t("Login.GAA.Version",{ version: `：v${version}`})}}</div>

          <!-- <n-button native-type="submit" type="primary" round block size="lg">
            {{$t("Login.GAA.Login")}}
          </n-button> -->
          <br/>
          <a @click="ssoLogin">
            <n-button class="g-signin2" data-onsuccess="onSignIn" type="primary" round block size="lg">
              {{$t("Login.GAA.Dot_Dot_Cloud")}}
            </n-button>
          </a>
          <!-- <div class="pull-left">
            <h6>
              <router-link class="link footer-link" to="/register">
                Create Account
              </router-link>
            </h6>
          </div>

          <div class="pull-right">
            <h6><a href="#pablo" class="link footer-link">Need Help?</a></h6>
          </div> -->
          <br><br>
          <!-- <el-button type="text" class="w-100" @click="goToQcPos">點此前往平板接單機介面</el-button> -->
        </div>
      </card>
    </form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import axios from "axios";

export default {
  name: 'login',
  data() {
    return {
      signinError: false,
      remainingSeconds: 0,
      countdownId: null,
      signLockError: false,
      model: {
        account: "",
        email: '',
        password: ''
      }
    };
  },
  computed: {
    version() {
      return process.env.PACKAGE_VERSION;
    },
    logoSrc() {
      // "img/qc_logo.png"
      return process.env.VUE_APP_LOGO;
    },
    formattedTime() {
      const minutes = Math.floor(this.remainingSeconds / 60);
      const seconds = this.remainingSeconds % 60;
      return `${minutes} 分 ${seconds} 秒`;
    }
  },
  watch: {
    'model.email': function(val){
        if(typeof val == 'string') this.model.email = val.trim();
    },
    remainingSeconds: function(newRemainingSeconds) {
      if (newRemainingSeconds <= 0) {
        clearInterval(this.countdownId);
        this.signLockError = false;
      }      
    }
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async login() {
      
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        // TIP use this.model to send it to api and perform login call
        
        // 因為 action 包裝了 Promise 所以可以使用 then 和 catch 來接收非同步回傳狀態
        this.$store.dispatch('login', {
          type: 'gaa',
          username: this.model.email,
          password: this.model.password
        })
        .then(() => { // 接收 resolve
          // console.log('3. get Promise resolve');
          setTimeout(() => {
            // 使用 $router.push 轉跳到 hello Page
            this.$router.push('/');
          }, 300);
        })
        .catch((e) => { // 接收 reject
          console.log(e.data.message)
          if (e.data.remaining_seconds) {
              this.signinError = false;
              this.signLockError = true;
              this.remainingSeconds = e.data.remaining_seconds;
              this.startCountdown();
            } else {
              this.signinError = true;
              console.log('error get Promise reject!' + e.stack);
            }
        });
      }
    },
    // startCountdown(){
    //    if(this.countdownId != null){
    //      clearInterval(this.countdownId);
    //      this.countdownId = null;
    //    }
    //    this.countdownId = setInterval(() => {
    //     this.remainingSeconds--;
    //   }, 1000);
    // },
    async ssoLogin() {
      //设置参数
      // axios.get("https://c98b-125-228-206-10.ngrok-free.app/oauth/dotdot", {
      //   headers: {
      //     "Cache-Control": "no-cache",
      //     "Content-Type": "application/x-www-form-urlencoded",
      //   },
      // }).then((response) => {
      //   console.log("sss", response)
      //   this.$route.push("/");
      // }).catch((err) => {
      //   console.log("Error Response", err);
      // });

      // try {
      //   //请替换成你的后端API的实际路径
      //   const response = await axios.post(`http://localhost:3005/oauth/getAuthURL`, {
      //     responseType: 'code',
      //     clientId: 'aa2d3727-7368-547b-874f-bb13551eda89',
      //     redirectUri: 'http://localhost:3005/oauth/dotdot/callback',
      //     scope: 'openid',
      //     state: 'e03='
      //   });
      //   // assuming response.data.url is the received URL where we need to redirect the user.
      //   window.location = response.data.url;
      // } catch (error) {
      //   console.error('There was an error!', error);
      // }
      // try {
      //   const response = await axios.get(`http://localhost:3005/oauth/dotdot`);
      //   console.log(response)
      //     //处理响应 ...
      // } catch (error) {
      //     console.error('There was an error!', error);
      // }
      // return;

      // const params = new URLSearchParams();
      // params.append('response_type', 'code');
      // params.append('client_id', 'aa2d3727-7368-547b-874f-bb13551eda89');
      // params.append('redirect_uri', `${process.env.VUE_APP_APIHOST}/oauth/dotdot/callback`);
      // params.append('scope', 'openid');
      // params.append('state', JSON.stringify({type: 'gaa'}));

      //重定向用户到认证服务器
      window.location = `${process.env.VUE_APP_APIHOST}/oauth/dotdot`;
      // window.location = `https://oidc-dev.ddc.ai/auth?${params.toString()}`;
    },
    goToQcPos() {
      window.open(`${process.env.BASE_URL}qcpos/login`, '_blank');
    }
  },
  created() {
    this.signinError = this.$route.query.error == "userNotFound" || false;
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
